export default "__VITE_PUBLIC_ASSET__55646afb__"